import React from 'react'

import config from '../config.js'

import axios from 'axios'

import {withRouter} from 'react-router-dom'

import { MuiThemeProvider } from '@material-ui/core/styles'

import { Button, Grid, TextField } from '@material-ui/core/'

import Contacts from './Contacts'
import InviteFromFacebook from './InviteFromFacebook'
import FriendInvites from './FriendInvites'
import SystemMessageSnackbar from './SystemMessageSnackbar'
import LinkButton from "./LinkButton";
import FriendSearch from "./FriendSearch";
import {isMobile} from "../Helpers/clientCommunication";
import {sendExternalInvite, sendInternalInvite, sendPhoneInvite, SocialInvite} from "../Helpers/invites";
import ConsoleLogViewer from "./ConsoleLogViewer";

class Invites extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      device: props.device,

      friendEmail: '',
      friendMessage: '',
      friendInvitations: undefined,

      systemMessage: {}
    }
  }

  callingAjax = false

  // Function to notify the server that a friend invitation has been extended to a particular phone number
  sendPhoneInvite = (aid, phoneNumber, firstName, lastName) => {
    const invite =
      new SocialInvite(
        aid,
        null,
        null,
        phoneNumber,
        null,
        firstName,
        lastName)
    sendPhoneInvite(invite,
      () => {
        // Invite sent successfully
        this.setState(
          {
            invited: true
          }, () => {
            // Updating the invites list is a good idea so the user knows who they've invited (even if they would have to scroll down to see)
            this.invitesGetList(this.props.aid)
          }
        )

      },
      (error) => {
        // Failed to send invite
        this.setState((state, props) => ({
          systemMessage: {
            message:
              'There was an error sending an invitation to your friend. Please try again later.',
            type: 'error',
            duration: 6000,
            timestamp: new Date().getTime()
          }
        }))
      })
  }

  sendInternalInvite = (aid, fid) => {
    const invite =
      new SocialInvite(
        aid,
        fid,
        null,
        null,
        null,
        null,
        null);
    sendInternalInvite(invite,
      () => {
        // Invite sent successfully
        this.setState((state, props) => ({
          invited: true,

          systemMessage: {
            message: 'Your invitation was sent successfully.',
            type: 'success',
            duration: 6000,
            timestamp: new Date().getTime()
          }
        }))
      },
      (error) => {
        // Failed to send invite
        this.setState((state, props) => ({
          systemMessage: {
            message:
              'There was an error sending an invitation to your friend. Please try again later.',
            type: 'error',
            duration: 6000,
            timestamp: new Date().getTime()
          }
        }))
      })
  }

  sendExternalInvite = (aid, email, firstName, lastName, message) => {
    const invite =
      new SocialInvite(
        aid,
        null,
        email,
        null,
        message,
        firstName,
        lastName)
    sendExternalInvite(invite,
      () => {
        // Invite sent successfully
        this.setState(
          {
            systemMessage: {
              message: 'Your invitation was sent successfully!',
              type: 'success',
              duration: 6000,
              timestamp: new Date().getTime()
            }
            // Maybe add a state here so the button used to make the invitation turns off?
          },
          () => {
            // Updating the invites list is a good idea so the user knows who they've invited (even if they would have to scroll down to see)
            this.invitesGetList(this.props.aid)
          }
        )
      },
      (error) => {
        // Failed to send invite
        this.setState({
          systemMessage: {
            message:
              'There was an error sending your invitation. Please try again later.',
            type: 'error',
            duration: 6000,
            timestamp: new Date().getTime()
          }
        })
      })
  }

  searchFormChangeHandler = e => {
    const target = e.target
    const value = target.value
    const name = target.name

    this.setState({
      [name]: value
    })
  }

  inviteFormSubmit = e => {
    e.preventDefault()

    const invite =
      new SocialInvite(
        this.props.aid,
        null,
        this.state.friendEmail,
        null,
        this.state.friendMessage,
        null,
        null)
    sendExternalInvite(invite,
      () => {
        // Invite sent successfully
        this.setState(
          {
            systemMessage: {
              message: 'Your invitation was sent successfully!',
              type: 'success',
              duration: 6000,
              timestamp: new Date().getTime()
            },
            friendEmail: '',
            friendMessage: ''
          },
          () => {
            // Updating the invites list is a good idea so the user knows who they've invited (even if they would have to scroll down to see)
            this.invitesGetList(this.props.aid)
          }
        )
      },
      (error) => {
        // Failed to send invite
        this.setState({
          systemMessage: {
            message:
              'There was an error sending your invitation. Please try again later.',
            type: 'error',
            duration: 6000,
            timestamp: new Date().getTime()
          },
          friendEmail: '',
          friendMessage: ''
        })
      })
  }

  inviteFormChangeHandler = e => {
    const target = e.target
    const value = target.value
    const name = target.name

    this.setState({
      [name]: value
    })
  }

  invitesGetList = aid => {
    axios
      .get(
        config.apiServer + '/api/v3/web/social/invites-external?aid=' + aid,
        //config.apiServer + '/api/v3/web/social/invites?aid=' + aid,
        {}
      )
      .then(
        response => {
          const json = response.data

          if (json.key === 'OK') {
            const resultsJson = json.results
            const resultsCount = resultsJson.length

            let resultsInvites = []

            if (resultsCount > 0) {
              // Fetch the invites and put each bit of JSON into an array
              for (let i = 0; i < resultsCount; i++) {
                resultsInvites.push(resultsJson[i])
              }
            }

            this.setState((state, props) => ({
              friendInvitations: resultsInvites
            }))
          } else {
            console.log(response)
          }
        },
        error => {
          console.log(error)
        }
      )
  }

  componentDidMount() {
    this.invitesGetList(this.props.aid)
  }

  render() {
    const {
      friendEmail,
      friendMessage,
      friendInvitations,

      systemMessage
    } = this.state

    const location = window.location.href
    console.log("Invites location: [" + location + "]")

    // Temporary fix for IE embedded browser in Cook'n Windows App.
    if (!String.prototype.endsWith) {
      String.prototype.endsWith = function(search, this_len) {
        if (this_len === undefined || this_len > this.length) {
          this_len = this.length;
        }
        return this.substring(this_len - search.length, this_len) === search;
      };
    }

    let invitesElement = ''
    if (location.endsWith("/invites")) {
      console.log("Invites load /invites endpoint")
      invitesElement = (
        <div>
          <div className="text-center">
            <h2>Invite Friends</h2>
            <h3 className="large">
              Add a friend so you can share recipes and message each other
              in&nbsp;<span className="dvo-secondary">Cook'n</span>!
            </h3>

            {this.InviteButtons()}
          </div>

          <h3 className="large text-center">
            Looking for someone not yet on{' '}
            <span className="dvo-secondary">Cook'n</span>? Invite&nbsp;them.
          </h3>

          <form
              id="friend-invite"
              className="text-center"
              style={{marginBottom: '3em'}}
              method="post"
              onSubmit={e => {
                this.inviteFormSubmit(e)
              }}
          >
            <TextField
                id="invite-friend-email"
                name="friendEmail"
                value={friendEmail}
                label="Enter your friend's email address"
                margin="dense"
                variant="outlined"
                fullWidth
                required
                onChange={this.inviteFormChangeHandler}
            />
            <TextField
                id="invite-friend-message"
                name="friendMessage"
                value={friendMessage}
                multiline
                rows="2"
                label="Type a message to your friend"
                margin="dense"
                variant="outlined"
                fullWidth
                onChange={this.inviteFormChangeHandler}
            />

            <p>
              <Button variant="contained" color="primary" type="submit">
                Invite
              </Button>
            </p>
          </form>

          <FriendInvites aid={this.props.aid} results={friendInvitations}/>
        </div>
      )
    } else if (location.endsWith("/friend-search")) {
      console.log("Invites load /friend-search endpoint")
      invitesElement = (
        <FriendSearch
            device={this.props.device}
            aid={this.props.aid}
            sendInternalInvite={this.sendInternalInvite}
        />
      )
    } else if (location.endsWith("/facebook")) {
      console.log("Invites load /facebook endpoint")
      invitesElement = (
        <InviteFromFacebook
            aid={this.props.aid}
            sendInternalInvite={this.sendInternalInvite}
        />
      )
    } else if (location.endsWith("/contacts")) {
      console.log("Invites load /contacts endpoint")
      invitesElement = (
        <Contacts
            aid={this.props.aid}
            device={this.props.device}
            version={this.props.version}
            sessionId={this.props.sessionId}
            friends={this.props.friends}
            sendPhoneInvite={this.sendPhoneInvite}
            sendInternalInvite={this.sendInternalInvite}
            sendExternalInvite={this.sendExternalInvite}
        />
      )
    } else {
      console.log("Invites endpoint not supported")
      invitesElement = (<h1>Endpoint Not Supported</h1>)
    }

    return (
      <MuiThemeProvider theme={config.theme}>
        <Grid container>
          <Grid item xs/>
          <Grid item xs={10}>
            {invitesElement}
          </Grid>
          <Grid item xs/>
        </Grid>
        <SystemMessageSnackbar systemMessage={systemMessage}/>
      </MuiThemeProvider>
    )
  }

  InviteButtons() {
    const device = window.queryParams.device
    let inviteBtns = ''
    if (device && isMobile(device)) {
      // Show all buttons
      inviteBtns = (
        <div className={"text-center"} style={{marginBottom: "40px"}}>
          {this.FriendSearchButton()}
          {this.FacebookButton()}
          {this.ContactsButton()}
        </div>
      )
    } else {
      // Only show Friend Search and Facebook buttons
      inviteBtns = (
        <div className={"text-center"} style={{marginBottom: "40px"}}>
          {this.FriendSearchButton()}
          {this.FacebookButton()}
        </div>
      )
    }
    return inviteBtns
  }

  FriendSearchButton() {
    const friendSearchBtn = (
      <LinkButton to={this.props.baseUrl + "/friend-search"}
                  variant={"contained"}
                  style={{
                    display: "table",
                    margin: "0 auto",
                    width: "250px",
                    textTransform: "none",
                    backgroundColor: "#ea4236",
                    color: "white",
                    marginBottom: "20px"
                  }}>
        Search Cook'n Network
      </LinkButton>
    )
    return friendSearchBtn
  }

  FacebookButton() {
    const facebookBtn = (
      <LinkButton to={this.props.baseUrl + "/facebook"}
                  variant={"contained"}
                  style={{
                    display: "table",
                    margin: "0 auto",
                    width: "250px",
                    textTransform: "none",
                    backgroundColor: "#1877f2",
                    color: "white",
                    marginBottom: "20px"
                  }}>
        Invite Facebook Friends
      </LinkButton>
    )
    return facebookBtn
  }

  ContactsButton() {
    const contactsBtn = (
      <LinkButton to={this.props.baseUrl + "/contacts"}
                  variant={"contained"}
                  style={{
                    display: "table",
                    margin: "0 auto",
                    width: "250px",
                    textTransform: "none",
                    backgroundColor: "#25cc42",
                    color: "white",
                    marginBottom: "20px"
                  }}>
        Invite from Contacts
      </LinkButton>
    )
    return contactsBtn
  }
}

export default withRouter(Invites)



// WEBPACK FOOTER //
// ./src/Components/Invites.js